/**
 * Stage a chip number typed in the sale-page animal preview into every
 * in-memory copy the preview can render from, so the controlled <input>
 * prop always equals what the user has typed (TICKET-01575).
 *
 * The preview renders `animalStore.animals.find(...) || newSale.animals[i]`,
 * and the debounced PATCH only updated animalStore.animals. Any re-render
 * while typing (the save's own "saved" indicator) made Preact re-apply the
 * stale embedded value to the DOM and wipe the digits typed so far.
 */
function stageSaleAnimalChipId({ saleStore, animalStore, animalId, value }) {
    const id = parseInt(animalId, 10);
    if (!id) {
        return;
    }
    const saleAnimals = saleStore?.newSale?.animals;
    if (Array.isArray(saleAnimals)) {
        const idx = saleAnimals.findIndex(a => a?.id === id);
        if (idx > -1) {
            saleStore.updateObjectKeyArrFieldValue('newSale', 'animals', idx, 'chipId', value);
        }
    }
    const visitorAnimals = saleStore?.visitorAnimals;
    if (Array.isArray(visitorAnimals)) {
        const idx2 = visitorAnimals.findIndex(a => a?.id === id);
        if (idx2 > -1) {
            saleStore.updateArrayKeyValue('visitorAnimals', idx2, 'chipId', value);
        }
    }
    animalStore.updateField(id, 'chipId', value);
}

export { stageSaleAnimalChipId };
